// Utility pure per gestione lingue: direzione testo, identificazione italiano,
// normalizzazione label per UI. Single source of truth condivisa tra backend
// (translationBackfill, PDF), admin (rendering) e chat (font/dir).
const RTL_LANGS = new Set(['ar', 'arabic', 'he', 'hebrew', 'fa', 'persian', 'farsi', 'ur', 'urdu']);
// Mappa nomi estesi → codici ISO 639-1. Il LLM a volte produce "arabic" invece
// di "ar"; questa mappa li riconcilia. Espandere se emergono nuovi alias.
const EXTENDED_TO_ISO = {
    arabic: 'ar',
    italian: 'it',
    english: 'en',
    french: 'fr',
    german: 'de',
    spanish: 'es',
    chinese: 'zh',
    japanese: 'ja',
    korean: 'ko',
    hebrew: 'he',
    persian: 'fa',
    farsi: 'fa',
    urdu: 'ur',
    russian: 'ru',
    ukrainian: 'uk',
    romanian: 'ro',
    hindi: 'hi',
    bengali: 'bn',
    thai: 'th',
};
function sanitizeLangInput(lang) {
    if (!lang)
        return '';
    return lang.trim().toLowerCase();
}
export function isItalianLang(lang) {
    return normalizeLangLabel(lang) === 'it';
}
export function getDirForLang(lang) {
    const c = sanitizeLangInput(lang);
    if (!c)
        return 'ltr';
    // Match anche su codici regional: 'ar-MA' → base 'ar'
    const base = c.split('-')[0];
    if (RTL_LANGS.has(c) || RTL_LANGS.has(base))
        return 'rtl';
    return 'ltr';
}
export function normalizeLangLabel(lang) {
    const c = sanitizeLangInput(lang);
    if (!c)
        return '';
    // Se è un nome esteso noto, mappa a ISO
    if (EXTENDED_TO_ISO[c])
        return EXTENDED_TO_ISO[c];
    // Altrimenti lowercase passthrough (preserva regional code: 'zh-cn', 'ar-ma')
    return c;
}
//# sourceMappingURL=lang.js.map